import { Address } from '../address/address';
import { Role } from '../../enums/role.enum';
import { UserStatus } from '../../enums/user-status.enum';
import { IdType } from '../../enums/id-type.enum';

export class User {
    id: string;
    firebaseId: string;
    password: string;
    documentType: IdType;
    document: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    cellularPhone: string;
    addresses: Address[];
    accept_tyc: boolean;
    roles: string[];
    status: UserStatus;
    dateCreated: Date;
    dateUpdated: Date;
    dateValidated: Date;
}
